
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { Action, State } from 'vuex-class';

import ModalContact from './ModalContact.vue';

@Component({
  components: {
    ModalContact,
  },
})
export default class Contact extends Vue {

  /* VUEX */
  @Action('actionUpdateSchoolContact', { namespace: 'academy' })
  private actionUpdateSchoolContact: any;
  @Action('actionSelectCurrentSchool', { namespace: 'academy'})
  private actionSelectCurrentSchool: any;

  // STATE
  @State('school', { namespace: 'academy' })
  private school: any;


  /* INITIALIZATION */

  @Prop({default: false})
  private isShow: boolean;

  constructor() {
    super();
  }

  private listener() {
    this.actionSelectCurrentSchool();
    this.$emit('update:isShow', false);
  }

  /* METHOD */

  private clickSubmit() {
    this.actionUpdateSchoolContact({listener: this.listener});
  }
}
